import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import 'sweetalert2/dist/sweetalert2.all.min';
import './styles/app.scss';

import { Amplify } from '@aws-amplify/core';
import App from './components/App';
import { Auth } from '@aws-amplify/auth';
import React from 'react';
import ReactDOM from 'react-dom';
import { amplifyConfigV4 } from './amplify/config';

Amplify.configure(amplifyConfigV4);
Auth.configure(amplifyConfigV4.Auth);

ReactDOM.render(<App />, document.getElementById('app'));
